import { setAddOns, setMonthlyFlex } from 'actions/expiryRenewalActions';
import { dispatch } from 'store';
import { PageModel, PaidUpgrade } from 'types/expiryRenewal';
import { EUROPEAN_RESCUE_PRODUCT_CODE } from './pricingUtils';

// European Rescue and Monthly Flex are mutually exclusive - the conflict modal resolves which one wins.
export const hasEuropeanRescue = (selected: PaidUpgrade[]): boolean => (
  selected.some(({ productCode }) => productCode === EUROPEAN_RESCUE_PRODUCT_CODE)
);

/**
 * Whether European Rescue is part of the cover the member already holds, as opposed to one
 * they are adding. Such a member stays annual whatever they do here, so this is read off
 * the quote's own content and never off their removals: dropping European Rescue must not
 * unlock Monthly Flex, and the conflict modal has no choice worth offering them.
 */
export const holdsEuropeanRescue = (pageModel: PageModel | null): boolean => (
  (pageModel?.addonsContent ?? []).some(
    (item) => item?.productCode === EUROPEAN_RESCUE_PRODUCT_CODE,
  )
);

// "Keep European Rescue and pay annually" - keeps the selection as-is and forces annual payment.
export const keepAnnual = (selectedWithEurRescue: PaidUpgrade[]): void => {
  dispatch(setAddOns(selectedWithEurRescue));
  dispatch(setMonthlyFlex(false));
};

// "Remove European Rescue and pay monthly" - drops the add-on and switches to Monthly Flex.
export const goMonthly = (selectedWithoutEurRescue: PaidUpgrade[]): void => {
  dispatch(setAddOns(selectedWithoutEurRescue));
  dispatch(setMonthlyFlex(true));
};
